import Vue from "vue";
import App from "./App.vue";
import i18n from "./i18n";

import router from "./router";
import "./registerServiceWorker";

Vue.config.productionTip = false;

const root = new Vue({
  i18n,
  router,
  render: (h) => h(App),
});

document.addEventListener("DOMContentLoaded", function () {
  root.$mount("#app");
});

// Tell Puppeteer the page is ready to be saved
document.dispatchEvent(new Event("__RENDERED__"));
